// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticateUserRequestModel {
    static getAttributeTypeMap() {
        return AuthenticateUserRequestModel.attributeTypeMap;
    }
}
AuthenticateUserRequestModel.discriminator = undefined;
AuthenticateUserRequestModel.attributeTypeMap = [
    {
        "name": "portalId",
        "baseName": "portalId",
        "type": "string"
    },
    {
        "name": "userName",
        "baseName": "userName",
        "type": "string"
    },
    {
        "name": "password",
        "baseName": "password",
        "type": "string"
    }
];
//# sourceMappingURL=authenticateUserRequestModel.js.map